import { render, staticRenderFns } from "./NewOnboardingSuccessModal.vue?vue&type=template&id=015b4229&scoped=true&"
import script from "./NewOnboardingSuccessModal.vue?vue&type=script&lang=ts&"
export * from "./NewOnboardingSuccessModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewOnboardingSuccessModal.vue?vue&type=style&index=0&id=015b4229&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b4229",
  null
  
)

export default component.exports